module.exports = __webpack_public_path__ + "static/Hebrews_Square-c76360e7746c94f0c71b2b04abeaeb16.jpg";